// Pin three.js to the classic XRWebGLLayer (2026-10-30, #5).
//
// three's WebXRManager.setSession takes the WebXR Layers path (an
// XRProjectionLayer) whenever 'createProjectionLayer' is on
// XRWebGLBinding.prototype. Chrome 156 started exposing it, and on the dev's
// SM-A366E nothing three drew reached the AR view, while a bare XRWebGLLayer
// page drew fine. ATO gains nothing from Layers on a phone, so the method is
// hidden for the one call where three makes that choice and restored right
// after — photo capture still needs XRWebGLBinding.getCameraImage.

type BindingScope = { XRWebGLBinding?: { prototype: object } }

export async function withClassicXrLayer<T>(
  fn: () => Promise<T>,
  scope: object = globalThis,
): Promise<T> {
  const proto = (scope as BindingScope).XRWebGLBinding?.prototype as
    | Record<string, unknown>
    | undefined
  const descriptor =
    proto != null ? Object.getOwnPropertyDescriptor(proto, 'createProjectionLayer') : undefined
  if (proto == null || descriptor == null) return fn()
  delete proto.createProjectionLayer
  try {
    return await fn()
  } finally {
    Object.defineProperty(proto, 'createProjectionLayer', descriptor)
  }
}
